import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Geist 400–700 and Geist Mono 400–500, self-hosted, latin subset: the same families and weights
// the reference page loads from Google Fonts, without a third-party request.
import '@fontsource/geist/latin-400.css';
import '@fontsource/geist/latin-500.css';
import '@fontsource/geist/latin-600.css';
import '@fontsource/geist/latin-700.css';
import '@fontsource/geist-mono/latin-400.css';
import '@fontsource/geist-mono/latin-500.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';

import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
